<!-- <mat-toolbar color="primary" class="topbar telative ifca-header mobile-header " *ngIf="!headerService.header">
    <button mat-icon-button (click)="toggleSideNav()" value="sidebarclosed" aria-label="close">
        <mat-icon>menu</mat-icon>
    </button>

    <div class="navbar-header">
        <a class="navbar-brand">
        
            <img src="assets/images/property-X.png" width="140" alt="">
            <span class="product-platform-title">Sales Online Platform</span>
        </a>
    </div>

    <span fxFlex></span>

    <app-header class="desktop-profile"></app-header>

</mat-toolbar> -->

<mat-toolbar class="ifca-general-header  mobile-header " *ngIf="!headerService.header">
    <div class="line-header" style="display: flex;">


        <button class="menu-burger" (click)="toggleSideNav()" value="sidebarclosed" mat-icon-button>
            <mat-icon>
                menu
            </mat-icon>
        </button>


        <div class="selected-container">
            <div class="domain"> {{ userSvc?.UserProfile?.name }}</div>

            <div class="selected-obj">
                {{ userSvc?.AccountName }}
            </div>
        </div>
    </div>

    <div class="bread-crumb" style="width: 100%;">
        <div style=" display:inline;float: left;">
            <span>Collaborative Property Solution</span>
        </div>

    </div>

</mat-toolbar>


<div *ngIf="headerService.header">
    <mat-toolbar class="ifca-general-header">
        <div class="line-header" style="display: flex;">


            <button class="menu-burger" mat-icon-button (click)="
    headerService.callBackFunction(headerService.header.headerIcon?.action)">
                <mat-icon>{{
    headerService.header.headerIcon?.icon || "keyboard_arrow_left"
  }}</mat-icon>
            </button>
            <app-switch-project *ngIf="!headerService.header?.disableProject" [projects]="project"
                [selected]="headerService.getProjectId()" style="display: flex; width: 100%;"
                (change)="headerService.header?.project?.function($event)"
                [disableSwitchProject]="headerService.header?.project?.disableSwitchProject">
            </app-switch-project>

            <div class="selected-container" *ngIf="headerService.header?.disableProject">
                <div class="domain"> {{ userSvc?.UserProfile?.name }}</div>

                <div class="selected-obj">
                    {{ userSvc?.AccountName}}
                </div>
            </div>
        </div>

        <div class="bread-crumb" style="width: 100%;">
            <div style=" display:inline;float: left;">
                <span *ngFor="let title of headerService.header?.leftBreadcrumb; let isLast=last">
                    <span *ngIf="isLast">{{ title }}</span>
                    <span *ngIf="!isLast">...</span>
                    <span *ngIf="!isLast">{{ ' / ' }}</span>
                </span>
            </div>
            <div style=" display:inline;float: right;">
                <span *ngFor="let title of headerService.header?.rightBreadcrumb; let isLast=last" class="active">
                    <span>{{ title }}</span>
                    <span *ngIf="!isLast">{{ ' / ' }}</span>
                </span>
            </div>
        </div>

    </mat-toolbar>

    <div *ngIf="headerService.header?.headerStep || 
              headerService.getMenu().length!=0 || 
              headerService.getButton() !=0 
              || (headerService.header?.title && !headerService.header?.disableProject)">
        <mat-list class="responsive-list">
            <mat-list-item class="item sm">
                <div class="smTitle-f" matLine>
                    <span *ngIf="!headerService.header?.disableProject">{{ headerService.header?.title }}</span>
                </div>
                <span class="subheader-step" *ngIf="headerService.header?.headerStep">
                    Step {{ headerService.header?.headerStep.current || "1" }}/{{
            headerService.header?.headerStep.total
          }}
                </span>

                <div *ngFor="let obj of headerService.getButton()">
                    <button mat-icon-button (click)="headerService.callBackFunction(obj?.action,true)" *ngIf="obj.icon"
                        [ngClass]="obj.butttonClass">
                        <mat-icon [ngClass]="obj.iconClass">{{ obj.icon }}</mat-icon>
                    </button>
                    <button mat-button (click)="headerService.callBackFunction(obj?.action,true)" color="primary"
                        *ngIf="!obj.icon" [ngClass]="obj.butttonClass">
                        {{ obj?.title }}
                    </button>
                </div>
                <div *ngIf="headerService.getMenu().length != 0">
                    <button mat-icon-button [matMenuTriggerFor]="menu">
                        <mat-icon>more_vert</mat-icon>
                    </button>
                    <mat-menu #menu="matMenu">
                        <button mat-menu-item *ngFor="let obj of headerService.getMenu()" [ngClass]="obj.class"
                            (click)="headerService.callBackFunction(obj?.action,true)">
                            <mat-icon *ngIf="obj?.icon" [ngClass]="obj.iconClass">{{ obj?.icon }}</mat-icon>
                            <span>{{ obj?.title }} {{obj?.class}}</span>
                        </button>
                    </mat-menu>
                </div>
            </mat-list-item>
            <mat-divider></mat-divider>
        </mat-list>

    </div>

</div>

<!-- <mat-toolbar color="primary" class="topbar telative ifca-header" *ngIf="(headerService.header && headerService.header.title) || headerService.header?.headerTitle">
  <button mat-icon-button (click)="
    headerService.callBackFunction(headerService.header.headerIcon?.action)">
      <mat-icon>{{
    headerService.header.headerIcon?.icon || "keyboard_arrow_left"
  }}</mat-icon>
  </button>

  <div class="navbar-header">
      <a class="navbar-brand">
          <span class="subheader-title"
              *ngIf="!headerService.header?.headerTitle || headerService.header?.headerTitle?.length==0">
              {{ headerService.header?.title }}
          </span>
          <span *ngIf="headerService.header?.headerTitle || headerService.header?.headerTitle?.length!=0">
              <span *ngFor="let title of headerService.header?.headerTitle;let isLast=last" class="subheader-title">
                  <span [ngClass]="title.class">{{ title?.title }}</span>
                  <span *ngIf="!isLast">
                      {{ title?.split || ' / ' }}
                  </span>
              </span>
          </span>
      </a>
  </div>

  <span fxFlex></span>

  <span class="subheader-step" *ngIf="headerService.header.headerStep">
      Step {{ headerService.header.headerStep.current || "1" }}/{{
    headerService.header.headerStep.total
  }}
  </span>

  <div *ngFor="let obj of headerService.getButton()">
      <button mat-icon-button (click)="headerService.callBackFunction(obj?.action)" *ngIf="obj.icon">
          <mat-icon>{{ obj.icon }}</mat-icon>
      </button>
      <button mat-button (click)="headerService.callBackFunction(obj?.action)" *ngIf="!obj.icon">
          <span class="subheader-word-action">
              {{ obj?.title }}
          </span>
      </button>
  </div>
  <div *ngIf="headerService.getMenu().length != 0">
      <button mat-icon-button [matMenuTriggerFor]="menu">
          <mat-icon>more_vert</mat-icon>
      </button>
      <mat-menu #menu="matMenu">
          <button mat-menu-item *ngFor="let obj of headerService.getMenu()"
              (click)="headerService.callBackFunction(obj?.action)">
              <mat-icon *ngIf="obj?.icon">{{ obj?.icon }}</mat-icon>
              <span>{{ obj?.title }}</span>
          </button>
      </mat-menu>
  </div>
</mat-toolbar> -->